<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
            <p class="header-title"> {{$t('team_management.title')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center" class="pr-5">
            <v-row class="d-flex justify-end">
              <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                  </template>
                  <v-card>
                      <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                          <v-container>
                            <v-row>
                                <v-col >
                                    <v-autocomplete v-model="selectBlockToAdd" :items="blocksToAdd" item-text="name" v-bind:label="$t('team_management.block')" :disabled="editedIndex > -1" return-object></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col >
                                    <v-autocomplete v-model="selectDepartmentToAdd" :items="departmentsToAdd" item-text="name" v-bind:label="$t('team_management.department')" :disabled="editedIndex > -1" return-object></v-autocomplete>
                                </v-col>
                            </v-row>

                              <v-row>
                                  <v-col>
                                      <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('team_management.name')"></v-text-field>
                                  </v-col>
                              </v-row>
                              <v-row>
                                  <v-col>
                                      <v-text-field v-model="editedItem.description" v-bind:label="$t('team_management.description')"></v-text-field>
                                  </v-col>
                              </v-row>
                                
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark @click="close">{{ $t('common.cancel')}}</v-btn>
                          <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </div>

        <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
            <template v-slot:top>
                <v-toolbar flat color="white" class="pt-5">
                  <v-row justify="start">
                      <v-col cols="12" sm="1">
                        <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined dense></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="2">
                        <v-autocomplete v-model="selectBlock" :items="blocks" item-text="name" return-object outlined dense></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="2">
                        <v-autocomplete v-model="selectDepartment" :items="departments" item-text="name" return-object outlined dense></v-autocomplete>
                      </v-col>
                    
                      <v-col cols="12" sm="7">
                        <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
                      </v-col>
                  </v-row>
                </v-toolbar>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <v-icon  small class="mr-2"  @click="editItem(item)">
                    edit
                </v-icon>
                <v-icon  small @click="deleteItem(item)">
                    delete
                </v-icon>
            </template>

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loading: true,
      numberPage: [
          5, 10, 15, 20, 25
      ],

      search: '',
      selectBlockToAdd: null,
      selectDepartmentToAdd: null,
      selectBlock: null,
      selectDepartment: null,
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('team_management.identify'), value: '_id' },
        { text: i18n.t('team_management.block'), value: 'parents[0].name' },
        { text: i18n.t('team_management.department'), value: 'parents[1].name' },
        { text: i18n.t('team_management.name'), value: 'name' },
        { text: i18n.t('team_management.description'), value: 'description' },
        { text: '', value: 'action', sortable: false }
      ],
      blocks: [],
      departments: [],
      blocksToAdd: [],
      departmentsToAdd: [],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
          v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('team_management.add_team') : i18n.t('team_management.edit_team')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      selectBlock (val) {
        if (val._id == -1) {
          const optionAll = {
            name : "Tất cả",
            _id : "-1"
          };
          this.departments = [optionAll];
          this.selectDepartment = optionAll;
        } else {
          this.getDepartmentByBlockId(val._id);
        }          
      },

      selectDepartment(val) {
        if (val._id == -1) {
          this.getAllTeam();
        } else {
          this.getTeamByDepartmentId(val._id);
        }           
      },

      selectBlockToAdd (val) {
        this.getDepartmentToAddByBlockId(val._id);      
      }
    },

    created () {
      this.initialize()
    },

    async mounted() {
      await this.getBlock(),
      await this.getAllTeam()
    },


    methods: {
      initialize () {
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.selectBlockToAdd = this.editedItem.parents[0];
        this.selectDepartmentToAdd = this.editedItem.parents[1];
        
        this.dialog = true
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete(process.env.VUE_APP_CONTEXT_URL + item._id);
          if(response.data && response.data.success) {
              // console.log(response.data);
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if(response.data && !response.data.success) {
              alert(i18n.t(response.data.message));
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (!this.editedItem.name || this.editedItem.name.length == 0) {
          alert(i18n.t('validate.name_empty'))
          return;
        }

        if (this.editedIndex > -1) {
          const self = this;
          const requestBody = self.editedItem;

          try {
            const response = await this.$http.put(process.env.VUE_APP_CONTEXT_URL + self.editedItem._id, requestBody);
            if (response.data && response.data.success) {
                Object.assign(this.desserts[this.editedIndex], this.editedItem);
                self.editedItem = {};
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        } else {
          const self = this;
          const requestBody = self.editedItem;
          requestBody.parents = (this.selectDepartmentToAdd.parents || []).concat([this.selectDepartmentToAdd]);
          
          try {
              const response = await this.$http.post("/context", requestBody);
              if (response.data && response.data.success) {
                  // console.log(response.data);

                  self.editedItem._id = response.data.data.id;
                  
                  if (this.selectDepartmentToAdd._id === this.selectDepartment._id || this.selectBlock._id == -1) {
                    this.desserts.push(self.editedItem);
                  }
                  
                  self.editedItem.index = this.desserts.length;
                  self.editedItem = {};

                  this.$fire({
                      title: i18n.t('common.success'),
                      text: "",
                      type: "success"
                  }).then(() => {

                  });

              } else if(response.data && !response.data.success) {
                  alert(i18n.t(response.data.message));
              } else {
                  alert(i18n.t('validate.request_error'));
              }
            } catch (e) {
                console.log(e.stack);
                alert(i18n.t('validate.request_error'));
            }
        }
        this.close()
      },

      async getBlock() {
          try {
              const response = await this.$http.get(process.env.VUE_APP_GET_BLOCK_URL);
              if (response.data && response.data.success) {
                const optionAll = {
                  name : "Tất cả",
                  _id : "-1"
                }

                this.blocks = [optionAll].concat(response.data.data);
                this.blocksToAdd = response.data.data;
                this.selectBlock = optionAll;
                this.selectBlockToAdd = this.blocksToAdd[0];
              }
          } catch (e) {
              //TODO add alert / flash service to Vue => Like Toast in Android

              //Only print stack trace if development
              console.log(e.stack);
              // dùng vue alert //alert(e.message);
          }
      },
      async getDepartment() {
          try {
              const response = await this.$http.get(process.env.VUE_APP_GET_DEPARTMENT_URL);
              if (response.data && response.data.success) {
                const optionAll = {
                  name : "Tất cả",
                  _id : "-1"
                }

                this.departments = [optionAll].concat(response.data.data);
                this.departmentsToAdd = response.data.data;
                this.selectDepartment = optionAll;
              }
          } catch (e) {
              //TODO add alert / flash service to Vue => Like Toast in Android

              //Only print stack trace if development
              console.log(e.stack);
              // dùng vue alert //alert(e.message);
          }
      },

      async getAllTeam() {
          try {
              const response = await this.$http.get(process.env.VUE_APP_GET_TEAM_URL);
              if (response.data && response.data.success) {
                const contextArr = response.data.data;
                contextArr.forEach((item, index) => item.index = index + 1);

                this.desserts = contextArr;
                this.loading = false;
              }
          } catch (e) {
              //TODO add alert / flash service to Vue => Like Toast in Android

              //Only print stack trace if development
              console.log(e.stack);
              // dùng vue alert //alert(e.message);
          }
      },

      async getDepartmentByBlockId(blockId) {
        try {
            const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + blockId);
            
            if (response.data && response.data.success) {
                this.departments = response.data.data;
                this.selectDepartment = this.departments[0];
            }
        } catch (e) {
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      },

      async getDepartmentToAddByBlockId(blockId) {
        try {
            const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + blockId);
            
            if (response.data && response.data.success) {
                this.departmentsToAdd = response.data.data;

                if (this.editedIndex < 0) {
                  this.selectDepartmentToAdd = this.departmentsToAdd[0];
                }  
            }
        } catch (e) {
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      },

      async getTeamByDepartmentId(departmentId) {
        try {
            const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + departmentId);
            
            if (response.data && response.data.success) {
              const contextArr = response.data.data;
              contextArr.forEach((item, index) => item.index = index + 1);

              this.desserts = contextArr;
            }
        } catch (e) {
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      }
    },
  }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>